import { render, staticRenderFns } from "./UserMenuPanel.vue?vue&type=template&id=62be80f7&scoped=true"
import script from "./UserMenuPanel.vue?vue&type=script&lang=js"
export * from "./UserMenuPanel.vue?vue&type=script&lang=js"
import style0 from "./UserMenuPanel.vue?vue&type=style&index=0&id=62be80f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be80f7",
  null
  
)

export default component.exports